class EphemeralState {
  private stationId?: number;
  private orgId?: number;
  private stationPermissions?: string[] | null;
  private stationRole?: string | null;
  private stationConfig?: Object;

  public setMyStationId(id: number) {
    this.stationId = id;
  }

  public setMyOrgId(id: number) {
    this.orgId = id;
  }

  public setPermissions(payload?: string[] | null) {
    this.stationPermissions = payload;
  }

  public setRole(payload?: string | null) {
    this.stationRole = payload;
  }

  public setConfiguration(payload?: any) {
    if (
      payload &&
      payload !== '' &&
      JSON.stringify(payload).length > 20
    ) {
      this.stationConfig = payload;
    }
  }

  public getMyStationId() {
    return this.stationId || 0;
  }

  public getMyOrgId() {
    return this.orgId || 0;
  }

  public getMyStationConfiguratation(): any | null {
    return this.stationConfig || null;
  }

  public getMyStationPermissions(): any | null {
    return this.stationPermissions || [];
  }

  public getMyStationRole(): any | null {
    return this.stationRole || null;
  }

  public getIsRoleSuperUser(): boolean {
    return this.stationRole === 'SUPER_USER';
  }
}

export default new EphemeralState();
